import cn from 'classnames';
import React, {FC, forwardRef} from 'react';
import MaskedInput from 'react-text-mask';

import {ICustomInput} from '../../PurchaseDateFullPagePopupTypes';

// eslint-disable-next-line react/display-name
const CustomInput: FC<ICustomInput> = forwardRef((props, ref: any) => {
    const {isEmptyDate, inputMask, inputLabelText, incorrectDateErrorText, testId, ...rest} = props;

    return (
        <div className='relative m-auto max-w-[312px]'>
            <div className='mb-4 text-14 leading-14 tracking-04 ltr:text-left rtl:text-right'>{inputLabelText}</div>
            <MaskedInput
                required
                {...rest}
                className={cn(
                    'block h-12 w-[312px] rounded-[3px] border border-solid border-border bg-romance px-[18px] py-3 text-left text-16 leading-15 focus:border-2 focus:border-black focus:outline-0',
                    {'border-2 border-error': isEmptyDate}
                )}
                ref={ref}
                mask={inputMask}
                data-testid={testId}
            />
            {isEmptyDate && (
                <div className='absolute mt-1 text-start text-12 leading-[1.67] tracking-04 text-error'>
                    {incorrectDateErrorText}
                </div>
            )}
        </div>
    );
});

export default CustomInput;
